import { render, staticRenderFns } from "./confirmChanges.vue?vue&type=template&id=70486934"
import script from "./confirmChanges.vue?vue&type=script&lang=js"
export * from "./confirmChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports